import { BOTH_CART_ITEM_RECEIVED } from "../constants/types/cartType";
import {
  ACTIVE_PATIENT,
  ACTIVE_PRACTITIONER,
  ROLE_CHANGED,
  SET_ACTIVE_PATIENT_NAME,
} from "../constants/types/roleType";

export const changeRole = (role) => (dispatch) => {
  dispatch({
    type: ROLE_CHANGED,
    payload: role,
  });
  dispatch({
    type: BOTH_CART_ITEM_RECEIVED,
    payload: null,
  });
};

export const setActivePatientForProfile = (patientId) => (dispatch) => {
  dispatch({
    type: ACTIVE_PATIENT,
    payload: patientId,
  });
};

export const setActivePatientName = (name) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_PATIENT_NAME,
    payload: name,
  });
};

export const setActivePractitionerForProfile =
  (practitionerId) => (dispatch) => {
    dispatch({
      type: ACTIVE_PRACTITIONER,
      payload: practitionerId,
    });
  };
